module.exports = __webpack_public_path__ + "img/share.227eff6b.svg";